import Link from '../../views/Link2rptd';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  reference_id: state.shift.assessment.reference_id
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    getRptLnkbyreferenceid: refid => {
      console.log('I am approbe:');
      dispatch(actions.getRptLnkbyreferenceid(refid));
      //   .then(() =>
      //   dispatch(push(`/${locale}/rdownload`))
      // )
    },

    gotopage: () => {
      console.log('approbe:');
      dispatch(push(`/${locale}/rdownload`));
    }
  };
};

const Link2rptd = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Link2rptd;



// WEBPACK FOOTER //
// ./src/components/container/Link2rptd/index.js